import { Network } from "@aptos-labs/ts-sdk";

// BKFC runs on Aptos, unlike every other flow in this app (which are EVM via
// thirdweb/wagmi). All BKFC config is isolated here; nothing outside src/bkfc
// and the BKFC routes/pages may depend on it. A missing env var must never
// crash the app at import time — the EVM flows have to keep working — so
// readiness is exposed as a flag and checked where the values are used.

export const BKFC_NETWORK: Network =
  process.env.REACT_APP_BKFC_NETWORK === "mainnet"
    ? Network.MAINNET
    : Network.TESTNET;

export const BKFC_NETWORK_LABEL =
  BKFC_NETWORK === Network.MAINNET ? "APTOS" : "APTOS TESTNET";

export const BKFC_GEOMI_API_KEY = process.env.REACT_APP_BKFC_GEOMI_API_KEY;
export const BKFC_MODULE_ADDRESS = process.env.REACT_APP_BKFC_MODULE_ADDRESS;

// Optional: reCAPTCHA is a Geomi gas-station contract-rule setting, not every
// environment has it turned on. Unset means getRecaptchaToken() resolves
// undefined and Geomi ignores pluginParams entirely.
export const BKFC_RECAPTCHA_SITE_KEY: string | undefined =
  process.env.REACT_APP_BKFC_RECAPTCHA_SITE_KEY;

export const isBkfcConfigured = (): boolean =>
  Boolean(BKFC_GEOMI_API_KEY && BKFC_MODULE_ADDRESS);

export function requireBkfcModuleAddress(): string {
  if (!BKFC_MODULE_ADDRESS) {
    throw new Error(
      "REACT_APP_BKFC_MODULE_ADDRESS is not set — BKFC claiming is not configured",
    );
  }
  return BKFC_MODULE_ADDRESS;
}

// demo helper for the "Tap the tag" overlay on non-production builds
export const BKFC_IS_PRODUCTION =
  process.env.REACT_APP_NODE_ENV === "production";
